export default function escapeExternalRedirectPath(redirectPath) {
  // Only allow redirection to relative urls or send back to home
  let newRedirectPath = '/';
  if (redirectPath) {
    const startsWithSlash = redirectPath.match(/^\//);
    const startsWithDoubleSlash = redirectPath.match(/^\/\//);
    const startsAndEndsWithSlashString = redirectPath.match(/^[A-Za-z0-9/]+$/);

    if (startsWithSlash && !startsWithDoubleSlash && startsAndEndsWithSlashString) {
      newRedirectPath = redirectPath;
    }
  }
  return newRedirectPath;
}
